export enum BalanceValidationStatus {
  PENDING = 'PENDING',
  IN_REVIEW = 'IN_REVIEW',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export interface BalanceSignupStatusFieldsResponseRaw {
  balance_validation_status: BalanceValidationStatus | null;
  balance_external_id: string | null;
  balance_onboarding_id: string | null;
  balance_onboarding_url: string | null;
  balance_credit_limit: number | null;
}

export interface BalanceSignupStatusContextFields {
  validationStatus: BalanceValidationStatus | null;
  externalId: string | null;
  onboardingId: string | null;
  onboardingUrl: string | null;
  creditLimit: number | null;
}
